<template>
  <embed src="/StackAssist%20Help.pdf" type="application/pdf" class="pdfView" />
</template>

<script>
export default {
  name: 'HelpPage',
}
</script>

<style scoped>
.pdfView {
  margin: 2rem;
  position: absolute;
  top: 0;
  left: 0;
  width: calc(100% - 4rem);
  height: calc(100% - 4rem);
}
</style>
